import { OrthographicCamera, PerspectiveCamera } from "three";
// import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { OrbitControls } from "./utils/orbit-controls";
import renderer from "./renderer";
import { rendererSize } from "./resize";
import { VECTOR_ZERO, VECTOR_ONE } from "./utils/math";

// Perspective camera defaults
export const FOV = 65;
const near = 0.1;
const far = 1000;

export function resetCamera(camera, zoom = 1, angle = VECTOR_ONE) {
  camera.position.set(angle.x * zoom, angle.y * zoom, angle.z * zoom);
  camera.lookAt(VECTOR_ZERO);
}

export function createPerspectiveCamera(aspect) {
  return new PerspectiveCamera(FOV, aspect, near, far);
}

export function createOrbitControls(camera) {
  return new OrbitControls(camera, renderer.domElement);
}

export const devCamera = createPerspectiveCamera(
  rendererSize.x / rendererSize.y
);
export const mainCamera = createPerspectiveCamera(
  rendererSize.x / rendererSize.y
);
export const postCamera = new OrthographicCamera(-1, 1, 1, -1, 0, 1);

export function updateCameras() {
  devCamera.aspect = rendererSize.x / rendererSize.y;
  mainCamera.aspect = rendererSize.x / rendererSize.y;
  devCamera.updateProjectionMatrix();
  mainCamera.updateProjectionMatrix();
}
